import { hasApiErrorCode } from '@/utils/apiError'

/**
 * Guards de erro das mutações de plantão (create/update/delete de Station),
 * compartilhados pelos modais de criação e edição do Dashboard.
 *
 * Segue o padrão de `src/modules/company/PostStation/errors.ts`: guards que
 * recebem `unknown` (o parâmetro de um `catch` sob `strict`) e fazem a
 * narrowing internamente, chamáveis direto no call site sem re-cast.
 */

/** Código do bloqueio de duração: plantão não pode exceder 24h. */
export const STATION_DURATION_ERROR_CODE = 'STATION_DURATION_GREATER_THAN_ALLOWED'

/**
 * True quando o backend rejeitou a mutação porque a duração do plantão excede
 * o limite permitido. O contrato legado transporta o código cru no campo
 * `message`; `hasApiErrorCode` já cobre `code`, `errorCode` e esse legado.
 */
export function isStationDurationExceeded(error: unknown): boolean {
  return hasApiErrorCode(error, STATION_DURATION_ERROR_CODE)
}

/**
 * Código estruturado da trava de check-in, publicado pelo backend no campo
 * `errorCode` (catálogo `src/modules/stations/domain/stations-errors.ts`).
 */
export const STATION_CHECK_IN_LOCK_CODE = 'DOCTOR_STATION_ALREADY_HAS_CHECK_IN'

/**
 * True quando o backend bloqueou a edição/remoção porque o plantão já possui
 * check-in. Detecção exclusivamente por código (`code`/`errorCode`/código cru
 * em `message`): o texto da resposta não é contrato e varia por endpoint.
 */
export function isStationCheckInLocked(error: unknown): boolean {
  return hasApiErrorCode(error, STATION_CHECK_IN_LOCK_CODE)
}
